import React from "react";
import MarketingNav from "../../components/MarketingNav";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import { Link } from "react-router-dom";
import { Radar, LineChart, Search, ArrowRight, Sparkles } from "lucide-react";

export default function ObservatoryProduct() {
  return (
    <div>
      <SEO
        path="/observatory"
        title="Observatory · Causal Trace Graph for AI Decisions"
        description="Observatory ingests every Sentry decision and builds a Causal Trace Graph — prompt, context, retrieval, tools, response, user. Decision search, custom dashboards, drift detection."
        keywords="LLM observability, AI decision tracing, causal trace graph, drift detection AI, LLM analytics, AI SIEM"
      />
      <MarketingNav />
      <section className="starfield text-cream">
        <div className="container-x py-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="chip chip-cream mb-6"><Sparkles size={12}/> Observatory</span>
              <h1 className="font-display text-4xl md:text-5xl font-bold">The Causal Trace Graph for every AI decision.</h1>
              <p className="text-cream/70 mt-5 text-lg">Post-hoc analytics, drift detection, and root-cause inference across every request Sentry (or your SDK) sends our way.</p>
              <div className="mt-8 flex gap-3">
                <Link to="/register" className="btn-primary">Start free <ArrowRight size={14}/></Link>
                <Link to="/pricing" className="btn-ghost-dark">Compare tiers</Link>
              </div>
            </div>
            <div className="rounded-2xl bg-white/5 border border-white/10 p-6 backdrop-blur">
              <div className="eyebrow text-[#FFD98A]/80 mb-3">CAUSAL TRACE GRAPH</div>
              <div className="grid grid-cols-3 gap-3 text-xs font-mono">
                {["User","Prompt","Context","Tool","Response","Decision"].map((n,i)=>(
                  <div key={n} className={`rounded-lg p-3 border text-center ${i===5?"bg-[#FF6B35] border-[#FF6B35] text-white font-bold":"bg-white/5 border-white/10"}`}>{n}</div>
                ))}
              </div>
              <div className="mt-5 space-y-2 text-xs font-mono text-cream/70">
                <div>→ USED_PROMPT</div>
                <div>→ RETRIEVED_FROM</div>
                <div>→ RETURNED_TO_DECISION</div>
                <div>→ TRIGGERED_BY_USER</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container-x py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { icon: Search, title: "Decision Search", desc: "Full-text and structured search across every prompt, response, and policy verdict — sub-second on billion-row spans (ClickHouse)." },
            { icon: LineChart, title: "Custom Dashboards", desc: "Slice by tenant, model, provider, policy, cost, latency, or user. Export to Datadog, Splunk, Snowflake, or Databricks." },
            { icon: Radar, title: "Drift Detection", desc: "Embedding-space anomaly scan + behavioral drift on cost, latency, denial rate, and tool-call patterns. Slack & PagerDuty routing." },
          ].map(f => (
            <div key={f.title} className="rounded-2xl bg-white border border-[rgba(17,30,51,0.08)] p-7">
              <div className="w-10 h-10 rounded-lg bg-[#FF6B35]/12 flex items-center justify-center mb-4">
                <f.icon size={18} className="text-[#FF6B35]" />
              </div>
              <div className="font-display font-bold text-navy text-lg">{f.title}</div>
              <p className="ink text-sm mt-2">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
